// AUTO-GENERATED — do not edit manually. Run: node scripts/build-sprite.mjs
// biome-ignore-all lint: AUTO-GENERATED
// biome-ignore-all format: AUTO-GENERATED

/* eslint-disable */
export const SPRITE_VERSION = '7de2eafa9e'
